import React, { ChangeEvent, FC, ReactNode } from 'react';

import { CmBox, CmErrorText, CmFlex, CmInput } from '@/components/uiParts';
import { FormError } from '@/validate';

type Props = {
  error: FormError;
  value: string;
  id?: string;
  placeholder: string;
  label?: ReactNode;
  suffix: '円' | 'km';
  handleChangeDeliveryFormInput: (e: ChangeEvent<HTMLInputElement>) => void;
};

export const DeliveryFormInput: FC<Props> = ({
  error,
  id,
  label,
  placeholder,
  value,
  suffix,
  handleChangeDeliveryFormInput,
}) => {
  return (
    <CmBox>
      {label}
      <CmFlex alignItems="flex-end">
        <CmInput
          {...{ id, placeholder, value }}
          onChange={handleChangeDeliveryFormInput}
          width="100px"
          isInvalid={error.isError}
        />
        <CmBox ml="5px">{suffix}</CmBox>
      </CmFlex>
      {error.isError && <CmErrorText mt="5px">{error.message}</CmErrorText>}
    </CmBox>
  );
};
